module.exports = __webpack_public_path__ + "img/scriptures.6ce7d7a6.webp";